module.exports = __webpack_public_path__ + "img/houses.e5979265.svg";